import { request } from '@/utils/request'

/* 通用接口 */
export const globalApi = {
  isArray: params => request.post('global/isArray', params), // 获取枚举类型
  getReference: () => request.get('global/reference'), // 获取枚举类型
  getSelectorOptions: params => request.get('selector', params), // 获取选择器候选项
}

